import * as i0 from "@angular/core";
var SidenavService = /** @class */ (function () {
    function SidenavService() {
    }
    /**
     * Class constructor
     */
    // constructor() {}
    /**
     * Set sidenav object
     *
     * @since 1.0.0
     *
     * @param sidenav Sidenav object
     */
    SidenavService.prototype.setSidenav = function (sidenav) {
        this.sidenav = sidenav;
    };
    /**
     * Open sidenav
     *
     * @since 1.0.0
     *
     * @returns Promise<MatDrawerToggleResult>
     */
    SidenavService.prototype.open = function () {
        return this.sidenav.open();
    };
    /**
     * Close sidenav
     *
     * @since 1.0.0
     *
     * @returns Promise<MatDrawerToggleResult>
     */
    SidenavService.prototype.close = function () {
        return this.sidenav.close();
    };
    /**
     * Toggle sidenav state
     *
     * @since 1.0.0
     *
     * @returns Promise<MatDrawerToggleResult>
     */
    SidenavService.prototype.toggle = function () {
        return this.sidenav.toggle();
    };
    SidenavService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SidenavService_Factory() { return new SidenavService(); }, token: SidenavService, providedIn: "root" });
    return SidenavService;
}());
export { SidenavService };
